import GameContext from "./States/GameContext.js";
import SplashScreen from "./States/SplashScreen.js";
import EndScreen from "./States/EndScreen.js";
import { Howl } from "howler";

window.addEventListener("contextmenu", function (e: Event) {
  e.preventDefault();
});

let splashScreen = new SplashScreen();

export let gameContext = new GameContext();

/**
 * Our update function, this will run every frame, and is responsible for moving the camera based on input.
 * This is where game logic would go if this was a complete game
 * @param dt - time elapsed since last frame.
 */
function update(dt: number) {
  gameContext.update(dt);
}

/**
 * This function runs just before rendering
 * Should update things that are only visual, contrary to game logic and physics for example.
 * This can be updating texture matrices etc
 * @param dt Time since last render call
 */
function preRendereringUpdate(dt: number) {
  gameContext.preRendereringUpdate(dt);
}

// Resize function to that will update the size of our game window when the browser window is resized
function resize() {
  let width = window.innerWidth;
  let height = window.innerHeight;

  splashScreen.guiRenderer.setSize(width, height);
  gameContext.resize(width, height);
}

// Run the resize function once to sync with the current size of the browser window
resize();

// Also add the resize function to run automatically when the browser window is resized
window.addEventListener("resize", () => {
  resize();
});

window.addEventListener("beforeunload", function (e: BeforeUnloadEvent) {
  gameContext.onExit();
});

// A timer to keep track of frame time
let lastUpdateTime = Date.now();

let frames = 0;
let fpsUpdateTimer = 0.0;
let accumulativeDt = 0.0;

const tickRate = 1.0 / 144.0;
const maxUpdatesPerFrame = 20;

/**
 * Animation function that takes care of requesting animation frames, calculating frame time and calls both update and render functions.
 */
function animate() {
  if (gameContext.game.isGameOver) {
    new EndScreen();
    gameContext.onExit();
    return;
  }
  requestAnimationFrame(animate);
  let now = Date.now();
  let dt = (now - lastUpdateTime) * 0.001;
  frames++;
  fpsUpdateTimer += dt;
  if (fpsUpdateTimer > 0.5) {
    gameContext.metaGui.fpsDisplay.textString = Math.floor(
      frames / fpsUpdateTimer,
    ).toString();
    frames = 0;
    fpsUpdateTimer = 0.0;
  }
  lastUpdateTime = now;

  accumulativeDt += dt;
  let updates = 0;
  while (accumulativeDt >= tickRate) {
    update(tickRate);
    accumulativeDt -= tickRate;
    updates++;
    if (updates >= maxUpdatesPerFrame) {
      accumulativeDt %= tickRate;
    }
  }

  preRendereringUpdate(dt);

  gameContext.draw();
}

let progress = { requested: 0, loaded: 0 };

const mainMenu = document.getElementById("main-menu")!;
const startBtn = document.getElementById("start-btn")! as HTMLButtonElement;
const controlsBtn = document.getElementById("controls-btn")!;
const controlsPanel = document.getElementById("controls-panel")!;

controlsBtn.addEventListener("click", () => {
  controlsPanel.classList.toggle("hidden");
});

let theme: Howl = new Howl({
  src: ["Assets/Audio/modified_intro.wav"],
  autoplay: true,
  loop: false,
  volume: 0.1,
  onend: function () {
    theme = new Howl({
      src: ["Assets/Audio/237127__tyops__arcade-theme-01.wav"],
      autoplay: true,
      loop: true,
      volume: 0.1,
    }).fade(0, 0.5, 3000);
  },
});

function startGame() {
  theme.fade(1, 0, 3000);
  setTimeout(() => {
    theme.unload();
  }, 3000);
  mainMenu.classList.add("hidden");
  gameContext.start();
  animate();
}

startBtn.addEventListener("click", () => {
  if (!startBtn.disabled) {
    startGame();
  }
});

gameContext.loadMeshes(progress).then(() => {
  splashScreen.destroy();
  startBtn.disabled = false;
  startBtn.classList.add("ready");
  startBtn.querySelector(".btn-text")!.textContent = "LAUNCH";
  startBtn.querySelector(".btn-subtext")!.textContent = "BEGIN MISSION";
});

function loadingScreenAnimate() {
  if (progress.requested == 0 || progress.loaded < progress.requested) {
    splashScreen.draw(progress);
    requestAnimationFrame(loadingScreenAnimate);
  }
}

requestAnimationFrame(loadingScreenAnimate);
